import { apiClient } from '../api';
import type {
    AdminProviderPayoutPrepareData,
    AdminProviderPayoutPrepareResponse,
    MarkProviderPayoutPaidPayload,
} from '../../types';
import type { ProviderPayout } from '../../types/payouts';

interface MarkProviderPayoutPaidResponse {
    message: string;
    data: ProviderPayout;
}

export async function prepareProviderPayout(contractId: number): Promise<AdminProviderPayoutPrepareData> {
    const response = await apiClient.get<AdminProviderPayoutPrepareResponse>(
        `/api/admin/provider-payouts/contracts/${contractId}/prepare`
    );

    return response.data;
}

export async function markProviderPayoutPaid(
    payoutId: number,
    payload: MarkProviderPayoutPaidPayload,
): Promise<ProviderPayout> {
    const formData = new FormData();
    formData.append('operator_bank_account_id', String(payload.operator_bank_account_id));
    formData.append('payment_reference', payload.payment_reference);
    formData.append('payment_method', payload.payment_method);
    formData.append('proof_file', payload.proof_file);
    if (payload.notes !== undefined && payload.notes !== '') {
        formData.append('notes', payload.notes);
    }

    const response = await apiClient.postForm<MarkProviderPayoutPaidResponse>(
        `/api/admin/provider-payouts/${payoutId}/mark-paid`,
        formData,
    );

    return response.data;
}

export async function downloadPayoutProof(payoutId: number): Promise<Blob> {
    const { blob } = await apiClient.getBlob(`/api/admin/provider-payouts/${payoutId}/proof`);
    return blob;
}
